import React from "react";
import styled from "styled-components";

import { palette } from "../../utils";

interface IButton {
    $disabled?: boolean
  type?: 'button' | 'submit' | 'reset'
  children: React.ReactNode
  onClick?: () => void
  style?: any
    disabled?: any
}

export const Button: React.FC<IButton> =
  ({
     type,
     children,
     onClick,
     style, disabled, $disabled
   }) => {
    return (
      <Container
        type={type}
        style={style}
        onClick={onClick}
        disabled={disabled}
        $disabled={$disabled}
      >
        {children}
      </Container>
    )
  }

Button.defaultProps = {
  type: 'button',
  style: {},
  onClick: undefined,
}

const Container = styled.button<{$disabled?: boolean}>`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 16px 0;
  border: none;
  border-radius: 40px;
  background: ${({$disabled}) => $disabled ? '#8a8a8a' : palette.bg.secondary};
  color: ${({$disabled}) => $disabled ? '#fff' : palette.text.secondary};
  font-weight: 700;
  font-size: 1.125em;
  line-height: 27px;

  &:hover {
    cursor:  ${({$disabled}) => $disabled ? 'not-allowed' : 'pointer'};
    transition: .3s;
    filter: brightness(0.9);
  }
`
